import { useBrand } from '@bnnvara/brand';
import { QualifioEmbed } from '@bnnvara/embeds';
import { GridItem } from '@bnnvara/grids';
import PropTypes from 'prop-types';
import React from 'react';

const ComposableQualifio = ({ qualifioId }) => {
  const brand = useBrand();

  return (
    <GridItem
      columnStartSm="1"
      columnEndSm="span 12"
      columnStartMd="2"
      columnEndMd="span 10"
      columnStartLg="3"
      columnEndLg="11"
    >
      <QualifioEmbed id={qualifioId} brand={brand.name} />
    </GridItem>
  );
};

ComposableQualifio.propTypes = {
  qualifioId: PropTypes.string.isRequired,
};

export default ComposableQualifio;
